document.addEventListener('DOMContentLoaded', function () {
  const article = document.querySelector('.article-faq-content');

  if (!article) return;

  const faqSchemaItems = [];

  function getText(element) {
    return (element.textContent || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getHeadingLevel(element) {
    const match = element.tagName.match(/^H([1-6])$/);
    return match ? Number(match[1]) : null;
  }

  function isFaqHeading(element) {
    if (!/^H[1-6]$/.test(element.tagName)) {
      return false;
    }

    const text = getText(element)
      .toLowerCase()
      .replace(/[?:\-–—]/g, '')
      .trim();

    return (
      text === 'faq' ||
      text === 'faqs' ||
      text === 'frequently asked questions' ||
      text === 'frequently asked question'
    );
  }

  function cleanQuestionText(text) {
    return text
      .replace(/^(?:q(?:uestion)?\s*[\.\:\-\)]\s*)/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cleanAnswerElement(element) {
    const clone = element.cloneNode(true);

    const walker = document.createTreeWalker(
      clone,
      NodeFilter.SHOW_TEXT
    );

    let node;

    while ((node = walker.nextNode())) {
      if (!node.textContent.trim()) continue;

      node.textContent = node.textContent.replace(
        /^\s*(?:a(?:nswer)?\s*[\.\:\-\)]\s*)/i,
        ''
      );

      break;
    }

    return clone;
  }

  function isQuestion(element, faqHeadingLevel) {
    const text = getText(element);

    if (!text) return false;

    const headingLevel = getHeadingLevel(element);

    if (headingLevel && headingLevel > faqHeadingLevel) {
      return true;
    }

    if (/^(?:q(?:uestion)?\s*[\.\:\-\)])/i.test(text)) {
      return true;
    }

    if (element.tagName === 'P') {
      const bold = element.querySelector(':scope > strong, :scope > b');

      if (bold && getText(bold).includes('?')) {
        return true;
      }
    }

    if (element.tagName === 'P' && text.includes('?')) {
      const questionPart = text.split('?')[0];

      if (
        questionPart.length <= 250 &&
        questionPart.split(/\s+/).length <= 35
      ) {
        return true;
      }
    }

    return false;
  }

  function extractQuestionAndAnswer(element) {
    const fullText = getText(element);

    const bold = element.querySelector(':scope > strong, :scope > b');

    if (bold && getText(bold).includes('?')) {
      const question = cleanQuestionText(getText(bold));

      const answerElement = element.cloneNode(true);
      const clonedBold = answerElement.querySelector(
        ':scope > strong, :scope > b'
      );

      if (clonedBold) {
        clonedBold.remove();
      }

      const answerText = getText(answerElement);

      return {
        question: question,
        answers: answerText
          ? [cleanAnswerElement(answerElement)]
          : []
      };
    }

    const questionMark = fullText.indexOf('?');

    if (questionMark !== -1) {
      const question = cleanQuestionText(
        fullText.slice(0, questionMark + 1)
      );

      const answerText = fullText
        .slice(questionMark + 1)
        .trim();

      if (!answerText) {
        return {
          question: question,
          answers: []
        };
      }

      const paragraph = document.createElement('p');
      paragraph.textContent = answerText;

      return {
        question: question,
        answers: [paragraph]
      };
    }

    return {
      question: cleanQuestionText(fullText),
      answers: []
    };
  }

  const faqHeadings = Array.from(
    article.querySelectorAll('h1,h2,h3,h4,h5,h6')
  ).filter(isFaqHeading);

  if (!faqHeadings.length) return;

  faqHeadings.forEach(function (faqHeading, sectionIndex) {
    if (faqHeading.dataset.faqProcessed === 'true') {
      return;
    }

    const faqHeadingLevel = getHeadingLevel(faqHeading) || 2;

    const faqGroups = [];

    let currentQuestion = null;
    let currentAnswers = [];
    let currentElements = [];

    function saveCurrentGroup() {
      if (!currentQuestion) return;

      if (currentAnswers.length) {
        faqGroups.push({
          question: currentQuestion,
          answers: currentAnswers,
          originalElements: currentElements
        });
      }

      currentQuestion = null;
      currentAnswers = [];
      currentElements = [];
    }

    let current = faqHeading.nextElementSibling;

    while (current) {
      const next = current.nextElementSibling;

      const headingLevel = getHeadingLevel(current);

      if (
        headingLevel &&
        headingLevel <= faqHeadingLevel
      ) {
        break;
      }

      if (
        current.classList.contains('article-faq-accordion')
      ) {
        current = next;
        continue;
      }

      if (isQuestion(current, faqHeadingLevel)) {
        saveCurrentGroup();

        const extracted = extractQuestionAndAnswer(current);

        currentQuestion = extracted.question;
        currentAnswers = extracted.answers;
        currentElements = [current];
      } else if (currentQuestion) {
        currentAnswers.push(
          cleanAnswerElement(current)
        );

        currentElements.push(current);
      }

      current = next;
    }

    saveCurrentGroup();

    if (!faqGroups.length) return;

    const accordion = document.createElement('div');

    accordion.className = 'article-faq-accordion';

    accordion.setAttribute(
      'data-faq-section',
      String(sectionIndex + 1)
    );

    accordion.style.setProperty(
      'width',
      '100%',
      'important'
    );

    accordion.style.setProperty(
      'max-width',
      '100%',
      'important'
    );

    faqGroups.forEach(function (group, index) {
      const questionText = cleanQuestionText(
        group.question
      );

      if (!questionText) return;

      const answerText = group.answers
        .map(function (element) {
          return getText(element);
        })
        .filter(Boolean)
        .join(' ')
        .trim();

      if (!answerText) return;

      const item = document.createElement('div');
      item.className = 'faq-item';

      item.style.setProperty(
        'width',
        '100%',
        'important'
      );

      const questionButton =
        document.createElement('button');

      questionButton.type = 'button';
      questionButton.className = 'faq-question';

      const answerId =
        `faq-answer-${sectionIndex}-${index}`;

      questionButton.setAttribute(
        'aria-expanded',
        'false'
      );

      questionButton.setAttribute(
        'aria-controls',
        answerId
      );

      /*
       * Force full width because some Shopify
       * themes override normal button styling.
       */
      questionButton.style.setProperty(
        'display',
        'flex',
        'important'
      );

      questionButton.style.setProperty(
        'width',
        '100%',
        'important'
      );

      questionButton.style.setProperty(
        'min-width',
        '100%',
        'important'
      );

      questionButton.style.setProperty(
        'max-width',
        '100%',
        'important'
      );

      questionButton.style.setProperty(
        'align-items',
        'center',
        'important'
      );

      questionButton.style.setProperty(
        'box-sizing',
        'border-box',
        'important'
      );

      const questionTextElement =
        document.createElement('span');

      questionTextElement.className =
        'faq-question-text';

      questionTextElement.textContent =
        questionText;

      questionTextElement.style.setProperty(
        'flex',
        '1 1 auto',
        'important'
      );

      questionTextElement.style.setProperty(
        'min-width',
        '0',
        'important'
      );

      const icon = document.createElement('span');

      icon.className = 'faq-icon';
      icon.textContent = '+';

      icon.setAttribute(
        'aria-hidden',
        'true'
      );

      /*
       * Important:
       * keeps the plus/minus on the far right.
       */
      icon.style.setProperty(
        'display',
        'inline-flex',
        'important'
      );

      icon.style.setProperty(
        'align-items',
        'center',
        'important'
      );

      icon.style.setProperty(
        'justify-content',
        'center',
        'important'
      );

      icon.style.setProperty(
        'flex',
        '0 0 30px',
        'important'
      );

      icon.style.setProperty(
        'width',
        '30px',
        'important'
      );

      icon.style.setProperty(
        'min-width',
        '30px',
        'important'
      );

      icon.style.setProperty(
        'height',
        '30px',
        'important'
      );

      icon.style.setProperty(
        'margin-left',
        'auto',
        'important'
      );

      icon.style.setProperty(
        'font-size',
        '30px',
        'important'
      );

      icon.style.setProperty(
        'line-height',
        '1',
        'important'
      );

      questionButton.appendChild(
        questionTextElement
      );

      questionButton.appendChild(icon);

      const answer =
        document.createElement('div');

      answer.className = 'faq-answer';
      answer.id = answerId;
      answer.hidden = true;

      group.answers.forEach(function (answerElement) {
        answer.appendChild(
          answerElement.cloneNode(true)
        );
      });

      item.appendChild(questionButton);
      item.appendChild(answer);

      accordion.appendChild(item);

      faqSchemaItems.push({
        '@type': 'Question',
        name: questionText,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answerText
        }
      });
    });

    if (!accordion.children.length) {
      return;
    }

    faqHeading.insertAdjacentElement(
      'afterend',
      accordion
    );

    faqGroups.forEach(function (group) {
      group.originalElements.forEach(
        function (element) {
          element.remove();
        }
      );
    });

    faqHeading.dataset.faqProcessed = 'true';

    accordion
      .querySelectorAll('.faq-question')
      .forEach(function (button) {
        button.addEventListener(
          'click',
          function () {
            const item =
              button.closest('.faq-item');

            if (!item) return;

            const answer =
              item.querySelector('.faq-answer');

            const icon =
              button.querySelector('.faq-icon');

            if (!answer) return;

            const isOpen =
              button.getAttribute(
                'aria-expanded'
              ) === 'true';

            button.setAttribute(
              'aria-expanded',
              String(!isOpen)
            );

            answer.hidden = isOpen;

            item.classList.toggle(
              'is-open',
              !isOpen
            );

            if (icon) {
              icon.textContent =
                isOpen ? '+' : '−';
            }
          }
        );
      });
  });

  /*
   * Dynamic FAQPage schema
   */
  if (
    faqSchemaItems.length > 0 &&
    !document.getElementById(
      'article-faq-jsonld'
    )
  ) {
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqSchemaItems
    };

    const schemaScript =
      document.createElement('script');

    schemaScript.type =
      'application/ld+json';

    schemaScript.id =
      'article-faq-jsonld';

    schemaScript.textContent =
      JSON.stringify(faqSchema).replace(
        /</g,
        '\\u003c'
      );

    document.head.appendChild(
      schemaScript
    );
  }
});